import { html, LitElement, css, unsafeCSS } from 'lit';

import '../parts/card';
import '../components/comments';
import '../components/decklist';
import '../components/buildlist';

import style from './class.scss';
import { convertToRoman, getNameFromURL, setTitle, trackPage } from '../shared/utils';
import { DATA_CLASSES } from '../data/sources';

function fixDesc(desc){
    if(desc === 'Add an additional campfire to each zone.')
        desc = 'Add campfire to each zone.'
    if(desc === 'Add a Potion of Healing to your starter deck.')
        desc = 'Add Potion of Healing to deck.';
    return desc;
}

export class ClassPage extends LitElement {

    static get properties() {
        return {
            name: String
        }
    }

    constructor() {
        super();
        this.name = null;     
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();    
        trackPage();  
        this.name = getNameFromURL();
        setTitle(this.name);
    }

    addStat(cls, type) {    
        let stats = [];   
        for(let i = 0; i < cls[type]; i++)
            stats.push(1);
        if(stats.length <= 0)
            return ''; 
        return html`
            ${stats.map(() => html`<img loading="lazy" class="stat" src="./images/${type.substr(0,3)}.webp" title=${type} alt=${type} />`)}
        `;
    }

    render() {    
        const cls = DATA_CLASSES.filter(c=>c.name===this.name)[0];
        return html`            
            <h1>
                <img loading="lazy" class="header-image" src="./images/classes/${cls.artwork}.webp" alt=${cls.name} /> ${cls.name}
            </h1>            
            <p>${cls.desc}</p>
            ${cls.dexterity || cls.intellect || cls.strength ? html`
            <h3>Base Stats</h3>
            ${this.addStat(cls,'dexterity')}
            ${this.addStat(cls,'intellect')}
            ${this.addStat(cls,'strength')}
            `:''}            
            <h3>Starting Weapons</h3>
            ${cls.weapons.map(wep=>html`
                <div class="row">
                    <card-part id=${wep}></card-part>
                </div>
            `)}
            <h3>Weapon Powers</h3>            
            ${cls.powers.map(wep=>html`
                <div class="row">
                    <card-part id=${wep} talent="true"></card-part>
                </div>
            `)}
            <h3>Starting Cards</h3>            
            ${cls.ability.map(wep=>html`
                <div class="row">
                    <card-part id=${wep}></card-part>
                </div>
            `)}
            <buildlist-component url=${`classbuilds/${this.name}?showall=true`} autohide="true" title="Builds"></buildlist-component>
            <h3>Progression</h3>            
            ${cls.progress.map((p,i)=>html`
                <div class="line block" style="${!p.name?'opacity:0.3':''}">
                    ${p.card ? html`
                    <card-part id=${p.card} imageonly="true"></card-part>
                    ` : html`
                    <div class="artwork nocursor"
                        style="background-image:url(./images/milestone/${(p.artwork || 'banner-of-stormcrest').replace(/ /g, '%20')}.webp);${!p.name?'display:none':''}">
                    </div>  
                    `}                    
                    <div class="name">
                        ${p.name}                                   
                    </div>           
                    ${p.card?html`
                    <card-part id=${p.card} inline="true"></card-part>
                    `:''}        
                    ${p.cost?html`                    
                    <div class="cost">${p.cost}</div>
                    `:''}                 
                </div>
                ${(i+1) % 3 === 0 ? html`<br>`:''}
            `)}            
            <decklist-component url=${`class/${this.name}`}></decklist-component>
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('class-page', ClassPage);